// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"0f4de57f","232":"cae01544","310":"57fdd7c1","831":"2ec2f294","940":"8e47df93","992":"e7340933"}[chunkId] + ".css";
};